import { StoredLocation } from "src/app/storage/models/stored-location";

/**
 * An instance of the StoredLocation model to be used for schema validation
 */
export const storedLocationInstance: StoredLocation = {
	AddressName: "",
	Address1: "",
	Address2: "",
	City: "",
	Region: "",
	PostalCode: "",
	AirportCode: "",
	ContactName: "",
	PhoneNumber: "",
	Instructions: ""
}